// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"141":"history","644":"account","945":"dashboard"}[chunkId] || chunkId) + "." + {"141":"60024aab","379":"22dc0f13","644":"e9cce8fc","945":"ab3e6935"}[chunkId] + ".css";
};